// **********************************************************
// Grab Cursor
// **********************************************************

document.addEventListener('DOMContentLoaded', () => {
  const grabCursorParents = document.querySelectorAll('[data-grab-cursor-parent]');
  let lastMouseX = 0;
  let lastMouseY = 0;
  let isDragging = false;

  grabCursorParents.forEach((parent) => {
    const cursorArea = parent.querySelector('[data-grab-cursor-area]');
    const cursor = parent.querySelector('.drag-cursor');

    if (!cursor) return;

    gsap.set(cursor, { opacity: 0, scale: 0.5 });

    const updateCursor = (x, y) => {
      cursor.removeAttribute('hidden');

      lastMouseX = x;
      lastMouseY = y;

      gsap.to(cursor, {
        x: lastMouseX,
        y: lastMouseY,
        duration: 0,
        ease: 'none',
      });

      checkIfInside();
    };

    const checkIfInside = () => {
      const rect = parent.getBoundingClientRect();
      const isInside =
        lastMouseX >= rect.left && lastMouseX <= rect.right && lastMouseY >= rect.top && lastMouseY <= rect.bottom;

      gsap.to(cursor, {
        opacity: isInside ? 1 : 0,
        scale: isInside ? 1 : 0.5,
        duration: 0.3,
        ease: 'power3.out',
      });
    };

    const onPointerMove = (e) => {
      if (isDragging) {
        updateCursor(e.clientX, e.clientY);
      }
    };

    cursorArea.addEventListener('pointerenter', (e) => {
      gsap.to(cursor, {
        scale: 1,
        opacity: 1,
        duration: 0.4,
        ease: 'power3.out',
      });
      updateCursor(e.clientX, e.clientY);
    });

    cursorArea.addEventListener('pointerleave', () => {
      gsap.to(cursor, {
        scale: 0.5,
        opacity: 0,
        duration: 0.4,
        ease: 'power3.out',
      });
    });

    cursorArea.addEventListener('pointerdown', () => {
      isDragging = true;
      window.addEventListener('pointermove', onPointerMove);
    });

    window.addEventListener('pointerup', () => {
      isDragging = false;
      window.removeEventListener('pointermove', onPointerMove);
    });

    // Fallback for passive movement
    cursorArea.addEventListener('pointermove', (e) => {
      if (!isDragging) updateCursor(e.clientX, e.clientY);
    });

    window.addEventListener('scroll', checkIfInside);
  });
});
